<div class="adx-dashboard-container" de-root>
  <!-- Header -->
  <app-header [loggedUser]="loggedUser"></app-header>
  <!-- Main Content -->
  <app-main class="adx-main-content" [loggedUser]="loggedUser"></app-main>
</div>
